/**
 * Estados del mueble, iguales a las constantes de Furniture.
 *
 * Entre Asignado y Almacén se mueve solo, según entre o salga de un control.
 * A mano solo tiene sentido darlo de baja, y eso se hace desde el botón del
 * listado; el backend lo rechaza si el mueble todavía está puesto en un
 * cliente.
 *
 * El código guardado sigue siendo 'F'. Se muestra como Almacén y no como
 * Libre porque el mueble no está disponible en abstracto: está físicamente
 * en el almacén, listo para salir a un cliente.
 */
export const ESTADOS_MUEBLE = [
  { id: 'A', descripcion: 'Asignado' },
  { id: 'B', descripcion: 'Dado de baja' },
  { id: 'F', descripcion: 'Almacén' }
];

/** Código del estado de baja. Se usa desde el listado, que es donde vive el botón. */
export const ESTADO_BAJA = 'B';

/** Nombre del estado. Si llega uno que no conocemos se muestra el código crudo. */
export const nombreEstadoMueble = (id) =>
  ESTADOS_MUEBLE.find((e) => e.id === id)?.descripcion || id || '';
